<template>
  <div class="settings-overlay" @click.self="$emit('close')">
    <div class="settings-panel">
      <button class="close-btn" @click="$emit('close')">×</button>
      <h2>Settings</h2>

      <p>
        <input type="checkbox" v-model="isClearFoods" @change="toggleClearFoods" />
        Clear food weights when app loads.
      </p>

      <p>
        <input type="checkbox" v-model="isShowCarbs" @change="toggleShowCarbs" />
        Show Carbs per 100g weight.
      </p>

      <p>
        <select v-model.number="insulinSelect" @change="updateInsulin">
          <option v-for="n in 31" :key="n-1" :value="n-1">{{ n-1 }}</option>
        </select>
        Carb ratio for 1 unit of insulin <br>(leave at 0 to not use)
      </p>

      <hr />

      <!-- Export section -->
      <p>
        <button @click="exportData">Export Data</button>
      </p>
      <p v-if="exportMessage" class="message" v-html="exportMessage"></p>

      <!-- Import section -->
      <p>
        <input type="text" v-model="importReference" placeholder="Enter file reference" />
        <button @click="importData">Import Data</button>
      </p>
      <p v-if="importMessage" class="message" v-html="importMessage"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Settings",
  props: {
    showCarbs: { type: Boolean, default: false },
    showClearFoods: { type: Boolean, default: false },
    insulinRatio: { type: Number, default: 0 },
    foodListData: { type: Object, default: () => ({ carblist: [] }) } // pass the current food list
  },
  data() {
    return {
      insulinSelect: this.insulinRatio,
      isClearFoods: this.showClearFoods,
      isShowCarbs: this.showCarbs,
      exportMessage: "",
      importReference: "",
      importMessage: ""
    };
  },
  methods: {
    updateInsulin() {
      this.$emit("update-insulin", this.insulinSelect);
      localStorage.setItem("insulinRatio", this.insulinSelect);
    },
    toggleShowCarbs() {
      this.$emit("toggle-show-carbs", this.isShowCarbs);
      localStorage.setItem("showCarbs", this.isShowCarbs);
    },
    toggleClearFoods() {
      this.$emit("toggle-clear-foods", this.isClearFoods);
      localStorage.setItem("clearFoods", this.isClearFoods);
    },

async exportData() {
  try {
    // grab the same JSON string stored in localStorage
    const payload = localStorage.getItem("carbdatalist") || "{}";

    const response = await fetch("https://data.diabetes.gb.net/carbcalc/userdata/savedata.php", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: `data=${encodeURIComponent(payload)}&filereference=${localStorage.fileReference || ""}`
    });

    const text = await response.text();
    if (!text.includes("Sorry")) {
      localStorage.fileReference = text;
      this.exportMessage = `Your data file reference is <b>${text}</b>. Use this to reload or share your data.`;
    } else {
      this.exportMessage = "Sorry, your data could not be saved.";
    }
  } catch (err) {
    this.exportMessage = "Error saving data: " + err.message;
  }

  setTimeout(() => (this.exportMessage = ""), 5000);
},
async importData() {
  if (!this.importReference) {
    this.importMessage = "Please enter a file reference.";
    setTimeout(() => (this.importMessage = ""), 5000);
    return;
  }
  try {
    const response = await fetch("https://data.diabetes.gb.net/carbcalc/userdata/getdata.php", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: `filereference=${encodeURIComponent(this.importReference)}`
    });

    const text = await response.text();
    if (!text.includes("Sorry") && text.trim() !== "") {
      let parsed;

      try {
        // Try JSON first
        parsed = JSON.parse(text);
      } catch (e) {
        // If not JSON, assume old format and convert
        parsed = this.convertOldFormat(text);
      }

      // Save in new format always
      localStorage.carbdatalist = JSON.stringify(parsed);
      this.$emit("imported-data", parsed); // Notify FoodList
      this.importMessage = `Data ${this.importReference} imported successfully.`;
    } else {
      this.importMessage = "Import failed, please check the reference number.";
    }
  } catch (err) {
    this.importMessage = "Error importing data: " + err.message;
  }
  setTimeout(() => (this.importMessage = ""), 5000);
},

  // Converts the old custom string format into new JSON
  convertOldFormat(oldStr) {
    const items = oldStr.split("|---|").filter(Boolean); // split and remove empties
    const carblist = items.map(item => {
      const parts = item.split("|=|");
      if (parts.length >= 3) {
        return {
          id: Math.random().toString(36).substr(2, 9), // generate random id
          name: parts[0].trim(),
          carbs: Number(parts[1]) || 0,
          weight: parts[2] === "null" ? null : Number(parts[2]) || 0
        };
      }
      return null;
    }).filter(Boolean);

    return { carblist };
  }


  }
};
</script>

<style scoped>
.settings-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0,0,0,0.4);
  z-index: 1000;
}

.settings-panel {
  position: absolute;
  top: 100px; bottom: 100px; left: 20px;
  min-width: 300px; max-width: 400px; width: 90%;
  background: #222;
  color: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 5px 20px rgba(0,0,0,0.5);
  overflow-y: auto;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
}

.message {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #ff4d4d;
}
</style>
